import type { ShopDto, UpdateOneShopDiscountDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useUpdatePortalDiscountSettings(shop: ShopDto) {
  const invalidateShop = useInvalidateShop(shop.id);

  return useApiMutation(
    "patch",
    "/shops/{shopId}/discounts",
    {
      invalidate: invalidateShop,
      mapVariables: (values: UpdateOneShopDiscountDto) => ({
        params: { path: { shopId: shop.id } },
        body: values,
      }),
    },
  );
}
